'use client'

import fukkuClasses from '@fukku/styles/classes.module.scss'
import type { ProductColor } from 'product/types'
import { ColorSelectorPicker } from 'product-components/components/ColorSelector/ColorSelectorPicker/ColorSelectorPicker'
import { useCallback } from 'react'
import styles from './ColorOption.module.scss'

export interface OnClickColorOptionProps {
	readonly colorId: string
	readonly relatedProductId: string | undefined
}

interface ColorOptionProps {
	readonly color: ProductColor
	readonly name: string
	readonly isSelected: boolean
	readonly onClickColor: (props: OnClickColorOptionProps) => void
	readonly dataTestId?: string
}
export function ColorOption({
	color,
	name,
	isSelected,
	onClickColor,
	dataTestId,
}: ColorOptionProps) {
	const { id, relatedProductId, bulletImg, label } = color

	const handleChange = useCallback(() => {
		onClickColor({
			colorId: id,
			relatedProductId,
		})
	}, [id, onClickColor, relatedProductId])

	return (
		<label className={styles.container} data-testid={dataTestId}>
			<input
				className={fukkuClasses.srOnly}
				type='radio'
				name={name}
				value={color.id}
				checked={isSelected}
				onChange={handleChange}
			/>
			<ColorSelectorPicker
				imageAlt={label}
				imageSrc={bulletImg}
				isSelected={isSelected}
			/>
		</label>
	)
}
